import React from 'react'
import OmacroWrapper from 'components/omacro'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'styles/global.scss'
import 'styles/utilities.scss'
import 'styles/headings.scss'
import 'styles/paragraphs.scss'
import 'styles/accordion.scss'
import 'styles/font.scss'
import 'styles/flex.scss'
import 'styles/text.scss'
import 'styles/position.scss'
import 'styles/color.scss'
import 'styles/hover.scss'
import 'styles/transition.scss'
import 'styles/transform.scss'
import 'styles/display.scss'
import 'styles/overflow.scss'
import 'styles/button.scss'
import 'styles/nav.scss'
import 'styles/backgrounds.scss'
import 'styles/footer.scss'
import 'styles/card.scss'
import 'styles/images.scss'
import 'styles/builder-carousel.scss'

export const wrapPageElement = ({ element, props }) => {
    return <OmacroWrapper {...props}>{element}</OmacroWrapper>
}

export const onPreRouteUpdate = ({ location, prevLocation }) => {
    const detail = { location, prevLocation }
    const event = new CustomEvent('PRE_ROUTE_UPDATE', { detail })
    window.dispatchEvent(event)
}

export const onRouteUpdate = ({ location }) => {
    window.dispatchEvent(new Event('navigate'))
    const { hash } = location
    const el = hash ? document.querySelector(hash) : null
    if (el) window.requestAnimationFrame(() => window.scrollTo(0, el.offsetTop))
}

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition, }) => {
    const savedScrollPosition = getSavedScrollPosition(location)
    window.requestAnimationFrame(() => window.scrollTo(...savedScrollPosition))
    return false
}
